import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const BusinessCreateContent = lazy(() => import('../../../components/Pages/Businesses/Create'));

export default function BusinessCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Business create`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <BusinessCreateContent />
      </Suspense>
    </Layout>
  );
}
